define('RunOnEveryPage/components/backToTop',[
],
    function () {
        function init() {
            $(window).scroll(showHideBackToTopButton);
            showHideBackToTopButton();   // call it initially so that the button is shown or hidden based on where we land on the page
        }

        function showHideBackToTopButton() {
            if ($(window).scrollTop() > 200) {
                $('.back-to-top-button').removeClass("d-none");
            } else {
                $('.back-to-top-button').addClass("d-none")
            }
        }

        return {
            init: init
        };
    }
);

